import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';

import {
  BRAND_SEGMENT_FACETS,
  MODEL_SEARCH_BRAND_ID_FIELD,
  MODEL_SEARCH_CLASS_ID_FIELD,
  MODEL_SEARCH_SEGMENT_ID_FIELD,
  ModelSearchFilter,
  ModelSearchService,
} from '@mitsubishi/shared/data-access';

export type CatalogScopeFacets = {
  brands: number[];
  segments: number[];
};

/** The brand and segment values available for a class, i.e. the options of the two selects. */
@Injectable({
  providedIn: 'root',
})
export class CatalogScopeFacetsService {
  private readonly modelSearchService = inject(ModelSearchService);

  facetsFor(classId: number): Observable<CatalogScopeFacets> {
    const filters: ModelSearchFilter = {};
    // Pages parse the class from the route, so guard against a NaN reaching the query.
    if (classId) {
      filters[MODEL_SEARCH_CLASS_ID_FIELD] = classId;
    }

    return this.modelSearchService
      .getFacets({
        facetFields: BRAND_SEGMENT_FACETS,
        filters,
      })
      .pipe(
        map(facets => {
          const brands = facets.find(facet => facet.field === MODEL_SEARCH_BRAND_ID_FIELD);
          const segments = facets.find(facet => facet.field === MODEL_SEARCH_SEGMENT_ID_FIELD);

          return {
            brands: brands ? brands.values.map(value => value.value) : [],
            segments: segments ? segments.values.map(value => value.value) : [],
          };
        }),
        catchError(() => of({ brands: [], segments: [] }))
      );
  }
}
